<template>
  <VView class="menu">
    <VText center><span>ODKRYJ <u>na nowo</u> pojazdy dickie toys!</span></VText>
    <VButtonGroup>
      <transition :name="getButtonTransitionName(item, index)"
        v-for="(item, index) in items" :key="index"
        appear
      >
        <VButton :to="item.to" :special="index === 3">{{ item.label }}</VButton>
      </transition>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VText from '@/components/VText.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Menu',
  components: {
    VView,
    VText,
    VButton,
    VButtonGroup,
  },

  data() {
    return {
      items: [
        { to: '/rules', label: this.$i18n.t('menu.rules') },
        { to: '/prizes', label: this.$i18n.t('menu.prizes') },
        { to: '/about', label: this.$i18n.t('menu.about') },
        { to: '/contest', label: this.$i18n.t('menu.contest') },
      ],
    };
  },

  methods: {
    getButtonTransitionName(item, index) {
      return index % 2 === 0
        ? 'bounceLeft'
        : 'bounceRight';
    },
  },
};
</script>

<style lang="scss" scoped>
.menu {}
</style>
